var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invoice-wrapper" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 8 } },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: { model: _vm.form, "label-width": "80px" }
              },
              [
                _vm.activeTab === 2
                  ? _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "开票日期" } },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                type: "daterange",
                                align: "right",
                                format: "yyyy-MM-dd",
                                "value-format": "yyyy-MM-dd",
                                "unlink-panels": "",
                                "range-separator": "至",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "picker-options": _vm.pickerOptions
                              },
                              model: {
                                value: _vm.form.date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "date", $$v)
                                },
                                expression: "form.date"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "结算单号" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "可输入结算单号查询" },
                          model: {
                            value: _vm.form.settleNo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "settleNo", $$v)
                            },
                            expression: "form.settleNo"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v("搜索")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn default-btn",
                        on: { click: _vm.resetData }
                      },
                      [_vm._v("重置")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-wrapper" },
      [
        _c("div", { staticClass: "tabs" }, [
          _c(
            "span",
            {
              staticClass: "tab",
              class: { "active-tab": _vm.activeTab === 1 },
              on: {
                click: function($event) {
                  return _vm.goToBillList(1)
                }
              }
            },
            [_vm._v("待开票")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "tab",
              class: { "active-tab": _vm.activeTab === 2 },
              on: {
                click: function($event) {
                  return _vm.goToBillList(2)
                }
              }
            },
            [_vm._v("已开票")]
          )
        ]),
        _vm._v(" "),
        _c(
          "el-dropdown",
          {
            staticClass: "batchbtn m-r-10",
            attrs: { trigger: "click", size: "medium", placement: "bottom" }
          },
          [
            _c("el-button", { attrs: { type: "primary", size: "small" } }, [
              _vm._v("\n         批量操作\n         "),
              _c("i", { staticClass: "el-icon-caret-bottom el-icon--right" })
            ]),
            _vm._v(" "),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _vm.activeTab === 1
                  ? _c(
                      "el-dropdown-item",
                      {
                        nativeOn: {
                          click: function($event) {
                            return _vm.exportData(1)
                          }
                        }
                      },
                      [_vm._v("批量开票")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-dropdown-item",
                  {
                    nativeOn: {
                      click: function($event) {
                        return _vm.exportData(2, "batch")
                      }
                    }
                  },
                  [_vm._v("导出明细")]
                ),
                _vm._v(" "),
                _vm.activeTab === 2
                  ? _c(
                      "el-dropdown-item",
                      {
                        nativeOn: {
                          click: function($event) {
                            return _vm.exportData(3)
                          }
                        }
                      },
                      [_vm._v("导出结算单明细")]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === 1,
                expression: "activeTab === 1"
              }
            ]
          },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.unInvoiceTableData,
                  "tooltip-effect": "dark",
                  "max-height": 300
                },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "序号", prop: "serialNum" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "title", label: "发票抬头" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "settleNo", label: "结算单号" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "receipt-no",
                              on: {
                                click: function($event) {
                                  return _vm.loadSettleItemList(
                                    scope.row.settleNo,
                                    "receiptNo"
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(scope.row.settleNo))]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "purchaseTotalAmount", label: "采购总金额" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "refundTotalAmount", label: "退货总金额" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { fixed: "right", label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              nativeOn: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.goInvoice(
                                    [scope.row.settleNo],
                                    scope.row
                                  )
                                }
                              }
                            },
                            [_vm._v("\n               去开票\n             ")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === 2,
                expression: "activeTab === 2"
              }
            ]
          },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.invoiceData,
                  "max-height": 400,
                  "row-key": "serialNum"
                },
                on: {
                  "selection-change": _vm.handleSelectionChange,
                  "expand-change": _vm.expandSelect
                }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { type: "expand", width: "55" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c(
                            "el-table",
                            { attrs: { data: props.row.child } },
                            [
                              _c("el-table-column", {
                                attrs: { label: "序号", prop: "serialNum" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "结算单号", prop: "settleNo" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "销售单号/售后单号",
                                  prop: "saleOrder"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "商品编码", prop: "skuCode" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "商品名称", prop: "skuName" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "采购数量",
                                  prop: "purchaseQuantity"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "采购单价",
                                  prop: "purchasePrice"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "采购总额/采退总额",
                                  prop: "purchaseAmount"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.detailCurrentPage,
                              "page-sizes": [10, 50, 100, 200],
                              "page-size": _vm.detailPageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.detailTotalCount
                            },
                            on: {
                              "size-change": function(val) {
                                return _vm.handleSizeChange(val, "detail")
                              },
                              "current-change": function(val) {
                                return _vm.handleCurrentChange(val, "detail")
                              },
                              "update:pageSize": function($event) {
                                _vm.detailPageSize = $event
                              },
                              "update:page-size": function($event) {
                                _vm.detailPageSize = $event
                              }
                            }
                          })
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "序号", width: "120", prop: "serialNum" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "receiptNo", label: "发票号", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "receipt-no",
                              on: {
                                click: function($event) {
                                  return _vm.bigImg(
                                    scope.row.receiptNo,
                                    "receiptNo"
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(scope.row.receiptNo))]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "title", label: "发票抬头", width: "120" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "billDate", label: "开票日期" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "purchaseTotalAmount",
                    label: "采购总金额",
                    width: "120"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "returnTotalAmount",
                    label: "退货总金额",
                    width: "120"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "invoiceAmount",
                    label: "篮字发票金额",
                    width: "120"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", { staticStyle: { color: "#2196FF" } }, [
                            _vm._v(_vm._s(scope.row.invoiceAmount))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "redFlushAmount",
                    label: "红字发票金额",
                    width: "120"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", { staticStyle: { color: "#FF4726" } }, [
                            _vm._v(_vm._s(scope.row.redFlushAmount))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "deliveryCompany",
                    label: "快递公司",
                    width: "120"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "deliveryNumber",
                    label: "快递单号",
                    width: "120"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "receipt-no",
                              on: {
                                click: function($event) {
                                  return _vm.bigImg(
                                    scope.row.deliveryNumber,
                                    "deliveryNumber"
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(scope.row.deliveryNumber))]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [10, 50, 100, 200],
            "page-size": _vm.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.totalCount
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
            "update:pageSize": function($event) {
              _vm.pageSize = $event
            },
            "update:page-size": function($event) {
              _vm.pageSize = $event
            }
          }
        }),
        _vm._v(" "),
        _vm.activeTab === 1
          ? _c(
              "div",
              { staticClass: "detail" },
              [
                _c("div", { staticClass: "detail-title" }, [
                  _vm._v("发票详情：")
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.detailLoading,
                        expression: "detailLoading"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.detailData, "tooltip-effect": "dark" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "序号", prop: "serialNum" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "salesOrderNo",
                        label: "销售单号/售后单号"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "skuCode", label: "商品编码" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "skuName", label: "商品名称" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "purchaseQuantity", label: "采购数量" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "purchasePrice", label: "采购单价" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "purchaseAmount",
                        label: "采购金额/采退金额"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            staticClass: "settle-modal",
            attrs: {
              visible: _vm.dialogVisible,
              width: "80%",
              "append-to-body": true
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogVisible = $event
              },
              close: function($event) {
                return _vm.handleBtn("cancel1")
              }
            }
          },
          [
            _c(
              "span",
              {
                staticClass: "dialog-title",
                attrs: { slot: "title" },
                slot: "title"
              },
              [
                _c("span", { staticClass: "title" }, [_vm._v("开票明细")]),
                _vm._v(" "),
                _c("span", { staticClass: "sub-title" }, [
                  _vm._v(
                    "(弹窗中的明细为选中的待开票列表，更多信息请点击导出明细按钮)"
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.handleBtn("next")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "下一步(" + _vm._s(this.selectKeys.length || 1) + "条)"
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.invoiceInfo.splitInvoiceItem &&
            _vm.invoiceInfo.splitInvoiceItem.length > 0
              ? _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%", "margin-top": "20px" },
                    attrs: {
                      data: _vm.invoiceInfo.splitInvoiceItem,
                      border: "",
                      height: "200",
                      "show-summary": "",
                      "sum-text": "小计"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "index", label: "序号", width: "180" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "settleNo", label: "结算单号" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "purchaseAmount", label: "采购总金额" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "refundAmount", label: "退货总金额" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.invoiceInfo.splitInvoiceItem &&
            _vm.invoiceInfo.splitInvoiceItem.length > 0
              ? _c(
                  "el-row",
                  { staticClass: "num" },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("待开增值税发票(篮字)：")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "blue" }, [
                        _vm._v("¥" + _vm._s(_vm.invoiceInfo.invoiceAmount))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("待开增值税发票(红字)：")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "red" }, [
                        _vm._v("¥" + _vm._s(_vm.invoiceInfo.redFlushAmount))
                      ])
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.invoiceInfo.deductInvoiceItem &&
            _vm.invoiceInfo.deductInvoiceItem.length > 0
              ? _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%", "margin-top": "20px" },
                    attrs: {
                      data: _vm.invoiceInfo.deductInvoiceItem,
                      border: "",
                      height: "200"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "index", label: "序号" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "title", label: "发票抬头", width: "180" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "settleNo", label: "结算单号" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "saleOrder",
                        label: "销售单号/售后单号",
                        width: "180"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "skuCode", label: "商品编码" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "skuName", label: "商品名称" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "purchaseQuantity", label: "采购数量" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "purchasePrice", label: "采购单价" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "purchaseAmount",
                        label: "采购金额/采退金额",
                        width: "180"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.invoiceInfo.deductInvoiceItem &&
            _vm.invoiceInfo.deductInvoiceItem.length > 0
              ? _c(
                  "el-row",
                  { staticClass: "num" },
                  [
                    _c("el-col", { attrs: { span: 1 } }, [
                      _c("span", { staticClass: "label" }, [_vm._v("合计：")])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 5 } }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(
                          "采购总金额：¥" +
                            _vm._s(_vm.invoiceInfo.purchaseTotalAmount)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 5 } }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(
                          "退货总金额：-¥" +
                            _vm._s(_vm.invoiceInfo.refundTotalAmount)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("待开增值税发票(篮字)：")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "blue" }, [
                        _vm._v("¥" + _vm._s(_vm.invoiceInfo.invoiceAmount))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 5 } }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("待开增值税发票(红字)：")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "red" }, [
                        _vm._v("¥" + _vm._s(_vm.invoiceInfo.redFlushAmount))
                      ])
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            staticClass: "settle-modal",
            attrs: {
              visible: _vm.dialogVisible2,
              width:
                _vm.invoiceInfo.redFlushAmount < 0 &&
                _vm.invoiceInfo.invoiceAmount > 0
                  ? "60%"
                  : "32%",
              "append-to-body": true
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogVisible2 = $event
              },
              close: function($event) {
                return _vm.handleBtn("cancel2")
              }
            }
          },
          [
            _c(
              "span",
              {
                staticClass: "dialog-title",
                attrs: { slot: "title" },
                slot: "title"
              },
              [
                _c("span", { staticClass: "title" }, [_vm._v("开票明细")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "sub-title",
                    staticStyle: { color: "#FF9D0C" }
                  },
                  [_vm._v("(发票号必须填写正确，提交后无法修改)")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function($event) {
                        return _vm.handleBtn("cancel2")
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.submitBill } },
                  [_vm._v("提交")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-wrapper" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 30 } },
                  [
                    _vm.invoiceInfo.invoiceAmount
                      ? _c(
                          "el-col",
                          {
                            attrs: {
                              span:
                                _vm.invoiceInfo.redFlushAmount < 0 &&
                                _vm.invoiceInfo.invoiceAmount > 0
                                  ? 12
                                  : 24
                            }
                          },
                          [
                            _c("div", { staticClass: "line" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("发票类型")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v("增值税发票")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "line" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("篮字发票金额")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "¥" + _vm._s(_vm.invoiceInfo.invoiceAmount)
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.blueBillingList, function(item, index) {
                              return _c(
                                "div",
                                { staticClass: "line bill" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _c("span", { staticClass: "red" }, [
                                      _vm._v("*")
                                    ]),
                                    _vm._v("开票号")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticStyle: { width: "87%" },
                                    attrs: { placeholder: "请输入开票号" },
                                    model: {
                                      value: item.num,
                                      callback: function($$v) {
                                        _vm.$set(item, "num", $$v)
                                      },
                                      expression: "item.num"
                                    }
                                  }),
                                  _vm._v(" "),
                                  index === 0
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-circle-plus-outline",
                                        on: {
                                          click: function($event) {
                                            return _vm.addBill("blue", "add")
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  index !== 0
                                    ? _c("i", {
                                        staticClass: "el-icon-remove-outline",
                                        on: {
                                          click: function($event) {
                                            return _vm.addBill(
                                              "blue",
                                              "remove",
                                              item.id
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "line" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _c("span", { staticClass: "red" }, [
                                    _vm._v("*")
                                  ]),
                                  _vm._v("开票日期")
                                ]),
                                _vm._v(" "),
                                _c("el-date-picker", {
                                  staticClass: "invoice-date",
                                  staticStyle: { width: "85%" },
                                  attrs: {
                                    format: "yyyy-MM-dd",
                                    "value-format": "yyyy-MM-dd",
                                    type: "date",
                                    placeholder: "请选择开票日期"
                                  },
                                  model: {
                                    value: _vm.modalData.blueDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.modalData, "blueDate", $$v)
                                    },
                                    expression: "modalData.blueDate"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "label m-b-10" }, [
                                _c("span", { staticClass: "red" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v("上传发票图片")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action: _vm.uploadUrl,
                                        "list-type": "picture-card",
                                        headers: _vm.headers,
                                        "on-preview": function(file) {
                                          return _vm.handlePictureCardPreview(
                                            file,
                                            "blue"
                                          )
                                        },
                                        "on-remove": function(file, fileList) {
                                          return _vm.handleRemove(
                                            file,
                                            fileList,
                                            "blue"
                                          )
                                        },
                                        "on-change": function(file, fileList) {
                                          return _vm.changeImage(
                                            file,
                                            fileList,
                                            "blue"
                                          )
                                        },
                                        "on-success": function(
                                          response,
                                          file,
                                          fileList
                                        ) {
                                          return _vm.handleSuccess(
                                            response,
                                            file,
                                            fileList,
                                            "blue"
                                          )
                                        },
                                        "on-error": function(file, fileList) {
                                          return _vm.handleError(
                                            file,
                                            fileList,
                                            "blue"
                                          )
                                        },
                                        "file-list": _vm.blueFileList,
                                        "before-upload": _vm.beforeAvatarUpload,
                                        multiple: true,
                                        name: "files"
                                      }
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dialog",
                                    {
                                      attrs: {
                                        visible: _vm.blueDialogImgVisible,
                                        "append-to-body": true
                                      },
                                      on: {
                                        "update:visible": function($event) {
                                          _vm.blueDialogImgVisible = $event
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          width: "100%",
                                          src: _vm.blueDialogImageUrl,
                                          alt: ""
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invoiceInfo.redFlushAmount
                      ? _c(
                          "el-col",
                          {
                            attrs: {
                              span:
                                _vm.invoiceInfo.redFlushAmount < 0 &&
                                _vm.invoiceInfo.invoiceAmount > 0
                                  ? 12
                                  : 24
                            }
                          },
                          [
                            _c("div", { staticClass: "line" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("发票类型")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v("增值税发票")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "line" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("红字发票金额")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "¥" + _vm._s(_vm.invoiceInfo.redFlushAmount)
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.redBillingList, function(item, index) {
                              return _c(
                                "div",
                                { staticClass: "line bill" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _c("span", { staticClass: "red" }, [
                                      _vm._v("*")
                                    ]),
                                    _vm._v("开票号")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticStyle: { width: "87%" },
                                    attrs: { placeholder: "请输入开票号" },
                                    model: {
                                      value: item.num,
                                      callback: function($$v) {
                                        _vm.$set(item, "num", $$v)
                                      },
                                      expression: "item.num"
                                    }
                                  }),
                                  _vm._v(" "),
                                  index === 0
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-circle-plus-outline",
                                        on: {
                                          click: function($event) {
                                            return _vm.addBill("red", "add")
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  index !== 0
                                    ? _c("i", {
                                        staticClass: "el-icon-remove-outline",
                                        on: {
                                          click: function($event) {
                                            return _vm.addBill(
                                              "red",
                                              "remove",
                                              item.id
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "line" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _c("span", { staticClass: "red" }, [
                                    _vm._v("*")
                                  ]),
                                  _vm._v(" 开票日期")
                                ]),
                                _vm._v(" "),
                                _c("el-date-picker", {
                                  staticClass: "invoice-date",
                                  staticStyle: { width: "83%" },
                                  attrs: {
                                    format: "yyyy-MM-dd",
                                    "value-format": "yyyy-MM-dd",
                                    type: "date",
                                    placeholder: "请选择开票日期"
                                  },
                                  model: {
                                    value: _vm.modalData.redDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.modalData, "redDate", $$v)
                                    },
                                    expression: "modalData.redDate"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "label m-b-10" }, [
                                _c("span", { staticClass: "red" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v("上传发票图片")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action: _vm.uploadUrl,
                                        "list-type": "picture-card",
                                        headers: _vm.headers,
                                        "on-preview": function(file) {
                                          return _vm.handlePictureCardPreview(
                                            file,
                                            "red"
                                          )
                                        },
                                        "on-remove": function(file, fileList) {
                                          return _vm.handleRemove(
                                            file,
                                            fileList,
                                            "red"
                                          )
                                        },
                                        "on-change": function(file, fileList) {
                                          return _vm.changeImage(
                                            file,
                                            fileList,
                                            "red"
                                          )
                                        },
                                        "on-success": function(
                                          response,
                                          file,
                                          fileList
                                        ) {
                                          return _vm.handleSuccess(
                                            response,
                                            file,
                                            fileList,
                                            "red"
                                          )
                                        },
                                        "on-error": function(file, fileList) {
                                          return _vm.handleError(
                                            file,
                                            fileList,
                                            "red"
                                          )
                                        },
                                        "file-list": _vm.redFileList,
                                        "before-upload": _vm.beforeAvatarUpload,
                                        multiple: true,
                                        name: "files"
                                      }
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dialog",
                                    {
                                      attrs: {
                                        visible: _vm.redDialogImgVisible
                                      },
                                      on: {
                                        "update:visible": function($event) {
                                          _vm.redDialogImgVisible = $event
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          width: "100%",
                                          src: _vm.redDialogImageUrl,
                                          alt: ""
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "line delivery" },
                  [
                    _c("span", { staticClass: "label" }, [
                      _c("span", { staticClass: "red" }, [_vm._v("*")]),
                      _vm._v("快递公司")
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticStyle: { width: "85%" },
                      attrs: { placeholder: "请输入快递公司" },
                      model: {
                        value: _vm.modalData.deliveryCompany,
                        callback: function($$v) {
                          _vm.$set(_vm.modalData, "deliveryCompany", $$v)
                        },
                        expression: "modalData.deliveryCompany"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "line" },
                  [
                    _c("span", { staticClass: "label" }, [
                      _c("span", { staticClass: "red" }, [_vm._v("*")]),
                      _vm._v("快递单号")
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticStyle: { width: "85%" },
                      attrs: { placeholder: "请输入快递单号" },
                      model: {
                        value: _vm.modalData.deliveryNo,
                        callback: function($$v) {
                          _vm.$set(_vm.modalData, "deliveryNo", $$v)
                        },
                        expression: "modalData.deliveryNo"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "label m-b-10" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("*")]),
                    _vm._v("上传快递图片")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-upload",
                        {
                          class: { disabled: _vm.deliveryFileList.length > 0 },
                          attrs: {
                            action: _vm.uploadUrl,
                            "list-type": "picture-card",
                            headers: _vm.headers,
                            "on-preview": function(file) {
                              return _vm.handlePictureCardPreview(
                                file,
                                "delivery"
                              )
                            },
                            "on-remove": function(file, fileList) {
                              return _vm.handleRemove(
                                file,
                                fileList,
                                "delivery"
                              )
                            },
                            "on-change": function(file, fileList) {
                              return _vm.changeImage(file, fileList, "delivery")
                            },
                            "on-success": function(response, file, fileList) {
                              return _vm.handleSuccess(
                                response,
                                file,
                                fileList,
                                "delivery"
                              )
                            },
                            "on-error": function(file, fileList) {
                              return _vm.handleError(file, fileList, "delivery")
                            },
                            "file-list": _vm.deliveryFileList,
                            "auto-upload": true,
                            "before-upload": _vm.beforeAvatarUpload,
                            name: "files"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            visible: _vm.deliveryDialogImgVisible,
                            "append-to-body": true
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.deliveryDialogImgVisible = $event
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.deliveryDialogImageUrl,
                              alt: ""
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            staticClass: "settle-modal",
            attrs: {
              visible: _vm.accountDialogVisible,
              width: "80%",
              "append-to-body": true
            },
            on: {
              "update:visible": function($event) {
                _vm.accountDialogVisible = $event
              }
            }
          },
          [
            _c(
              "span",
              {
                staticClass: "dialog-title",
                attrs: { slot: "title" },
                slot: "title"
              },
              [_c("span", { staticClass: "title" }, [_vm._v("查看原单")])]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c("el-button", { attrs: { type: "primary" } }, [
                  _vm._v("确认")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%", "margin-top": "20px" },
                attrs: { data: _vm.tableData, border: "", height: "100" }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "原单", width: "180" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "售后确认日期" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "售后单号" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount1", label: "商品编码" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount2", label: "商品名称" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount3", label: "售后确认数量" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount3", label: "采购单价" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount3", label: "售后总额" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%", "margin-top": "20px" },
                attrs: { data: _vm.tableData, border: "", height: "100" }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "暂未抵扣", width: "180" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "订单状态" }
                }),
                _vm._v(" "),
                _c("el-table-column", { attrs: { prop: "amount1" } }),
                _vm._v(" "),
                _c("el-table-column", { attrs: { prop: "amount1" } }),
                _vm._v(" "),
                _c("el-table-column", { attrs: { prop: "amount2" } }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount3", label: "剩余扣款数量" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount3", label: "采购单价" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount3", label: "剩余扣款总额" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%", "margin-top": "20px" },
                attrs: { data: _vm.tableData, border: "", height: "100" }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "已抵扣", width: "180" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "订单状态" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount1", label: "结算单" }
                }),
                _vm._v(" "),
                _c("el-table-column", { attrs: { prop: "amount2" } }),
                _vm._v(" "),
                _c("el-table-column", { attrs: { prop: "amount2" } }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount3", label: "扣款数量" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount3", label: "采购单价" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "amount3", label: "扣款总额" }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "viewer",
          {
            ref: "viewer",
            staticClass: "viewer",
            attrs: { images: _vm.imgList },
            on: { inited: _vm.inited }
          },
          _vm._l(_vm.imgList, function(src) {
            return _c("img", { key: src, attrs: { hidden: "", src: src } })
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15328890", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15328890","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settlementManage/invoice.vue
// module id = null
// module chunks = 